<template>
  <div>
    <v-dialog v-model="show_dialog_box" max-width="1200px">
      {{ data }}
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" class=" font-weight-bold light--text text-capitalize" color="primary"> <v-icon class="me-1" small>mdi-plus</v-icon> Add </v-btn>
      </template>
      <v-card color="pop_bg">
        <v-card-title>
          <span class="text-h6 dark--text">Add Article</span>
          <v-spacer></v-spacer>
          <v-btn color="dark" text @click="close"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-form @submit="updateFaq()" v-model="valid" ref="form">
          <v-layout wrap class="mx-5 my-5 wrap justify-md-end">
            <v-flex xs12 sm4 md2 class="mt-4">
              <h4 class="text-body-2 dark--text">Show Order</h4>
            </v-flex>
            <v-flex xs12 sm8 md2 class="mt-4">
              <v-text-field v-model="showOrder" :rules="[requiredValidator('showOrder')]" type="number" solo dense></v-text-field>
            </v-flex>
          </v-layout>

          <v-card-text>
            <v-container class="">
              <v-card-text>
                <v-card height="300">
                  <v-layout wrap class="mx-10 my-5 ">
                    <v-flex xs12 sm4 md2 class="mt-4">
                      <h4 class="text-body-2 dark--text">Heading En</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md10 class="mt-4">
                      <v-text-field v-model="headingEn" solo dense></v-text-field>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap class="mx-10 my-5 ">
                    <v-flex xs12 sm4 md2 class="mt-4">
                      <h4 class="text-body-2 dark--text">Heading Ar</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md10 class="mt-4">
                      <v-text-field v-model="headingAr" solo dense></v-text-field>
                    </v-flex>
                  </v-layout>

                  <v-layout wrap class="mx-10 my-5">
                    <v-flex xs12 sm3 md2 class="mt-2">
                      <h4 class="text-body-2 dark--text">Image (Web)</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md3>
                      <input type="file" accept="image/*" @change="onFileSelected($event)" />
                    </v-flex>
                    <v-snackbar v-model="snackbar" :timeout="3000">
                      {{ snackText }}
                    </v-snackbar>
                  </v-layout>

                  <v-layout wrap class="mx-10 my-5 mb-5">
                    <v-flex xs12 sm3 md2 class="mt-2">
                      <h4 class="text-body-2 dark--text">Image (Mobile)</h4>
                    </v-flex>
                    <v-flex xs12 sm8 md6>
                      <input type="file" accept="image/*" @change="onFileSelectedMob($event)" />
                    </v-flex>
                    <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                      {{ snackText }}
                    </v-snackbar>
                  </v-layout>
                </v-card>

                <v-card-subtitle class="pa-3">
                  <span class="text-h6 dark--text">Paragraph</span>
                  <v-spacer></v-spacer>
                </v-card-subtitle>

                <v-row v-for="(item, index) in paragraphs" :key="index">
                  <v-col cols="10">
                    <v-card>
                      <v-layout class="mx-3 mt-4">
                        <v-flex xs12 sm4 md2 class="mt-3">
                          <h4 class="text-body-2 dark--text">Title En</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10 class="mt-3">
                          <v-text-field v-model="item.titleEn" :rules="[requiredValidator('titleEn')]" solo dense></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mx-3 mt-4">
                        <v-flex xs12 sm4 md2 class="mt-3">
                          <h4 class="text-body-2 dark--text">Title Ar</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10 class="mt-3">
                          <v-text-field v-model="item.titleAr" :rules="[requiredValidator('title Ar')]" solo dense></v-text-field>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mx-3 my-4">
                        <v-flex xs12 sm4 md2 class="mt-2">
                          <h4 class="text-body-2 dark--text">description En</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10>
                          <client-only>
                            <VueEditor v-model="item.descriptionEn" />
                          </client-only>
                        </v-flex>
                      </v-layout>
                      <v-layout class="mx-3 my-4">
                        <v-flex xs12 sm4 md2 class="mt-2">
                          <h4 class="text-body-2 dark--text">description Ar</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md10>
                          <client-only>
                            <VueEditor v-model="item.descriptionAr" />
                          </client-only>
                        </v-flex>
                      </v-layout>

                      <v-layout class="mx-3 mt-6 ">
                        <v-flex xs12 sm3 md2>
                          <h4 class="text-body-2 dark--text">Image (Web)</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md3 class="mt-4">
                          <input type="file" accept="image/*" @change="onFileSelected($event, item)" />
                        </v-flex>

                        <v-flex xs12 sm8 md6 class="mt-4">
                          <v-row>
                            <v-radio-group v-model="item.imagePosition">
                              <v-radio label="Top" value="TOP"></v-radio>
                              <v-radio label="Bottom" value="BOTTOM"></v-radio>
                            </v-radio-group>
                          </v-row>
                        </v-flex>
                        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                          {{ snackText }}
                        </v-snackbar>
                      </v-layout>
                      <v-layout class="mx-3 mt-5 mb-5">
                        <v-flex xs12 sm3 md2 class="mt-2 ">
                          <h4 class="text-body-2 dark--text">Image (Mobile)</h4>
                        </v-flex>
                        <v-flex xs12 sm8 md6 class="mt-5 mb-5">
                          <input type="file" accept="image/*" @change="onFileSelectedMob($event, item)" />
                        </v-flex>
                        <v-snackbar v-model="snackbar" :timeout="3000" :color="snackColor">
                          {{ snackText }}
                        </v-snackbar>
                      </v-layout>
                    </v-card>
                  </v-col>
                  <v-col>
                    <div class="mt-5">
                      <v-btn v-if="index == 0" @click="createParagraph" class="light--text" text color="primary"> <v-icon class="" large>mdi-plus</v-icon> </v-btn>
                      <v-btn class="light--text" v-else @click="removeParagraph(item)" text color="error"> <v-icon class="" large>mdi-minus</v-icon> </v-btn>
                    </div>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-container>
          </v-card-text>
        </v-form>
        <v-card-actions class="justify-end mt-n8">
          <v-btn color="primary" class="mb-2 light--text mb-sm-4 text-capitalize" :width="$vuetify.breakpoint.smAndUp ? 120 : 90" @click="createArticle" :loading="btnloading" :disabled="!valid">
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar v-model="snackbarError" timeout="3000" right top color="success">
      {{ errorMsg }}
    </v-snackbar>
  </div>
</template>

<script>
import { requiredValidator } from "../../core/methods/validations";
// import ArticleTable from "../components/ArticleTable.vue";
import { VueEditor } from "vue2-editor";

export default {
  data() {
    return {
      btnloading: false,
      valid: true,
      errors: [],
      snackbar: false,
      snackbarError: false,
      snackColor: "",
      snackText: "",
      text: "",
      planShowType: "",
      selectedPackage: "",
      isActive: false,
      show_dialog_box: false,
      requiredValidator: requiredValidator,
      packagesList: [],
      showOrder: "",
      title: "",

      imagePosition: "",
      paragraphs: [],
      headingImage: null,
      headingImageMob: null,
      image: null,
      imageMob: null,
      headingEn: "",
      headingAr: "",
      errorMsg: "",
    };
  },
  props: {
    data: Object,
  },
  components: {
    // "app-article-table": ArticleTable,
    VueEditor,
  },
  created() {
    this.createParagraph();
  },

  methods: {
    removeParagraph(item) {
      this.paragraphs = this.paragraphs.filter(x => x.id != item.id);
    },
    createParagraph() {
      let paragraph = {
        titleEn: "",
        titleAr: "",
        descriptionEn: "",
        descriptionAr: "",
        image: null,
        imageMob: null,
        id: this.paragraphs.length + 1,
      };
      this.paragraphs.push(paragraph);
    },
    close() {
      this.show_dialog_box = false;
    },
    onFileSelected(event, item) {
      debugger;
      if (item) {
        let row = this.paragraphs.find(x => x.id == item.id);
        row.image = event.target.files[0];
      } else {
        const selectedFile = event.target.files[0];
        this.headingImage = selectedFile;
      }
    },
    onFileSelectedMob(event, item) {
      if (item) {
        let row = this.paragraphs.find(x => x.id == item.id);
        row.imageMob = event.target.files[0];
      } else {
        const selectedFile = event.target.files[0];
        this.headingImageMob = selectedFile;
      }
    },

    createArticle() {
      debugger;
      this.btnloading = true;
      if (!this.headingImage) {
        this.btnloading = false;
        this.snackbarError = true;
        this.errorMsg = "Please select header image";
        return false;
      }
      let subHeadings = [];
      this.paragraphs.forEach(item => {
        let subtitles = {
          titleEn: item.titleEn,
          titleAr: item.titleAr,
          descriptionEn: item.descriptionEn,
          descriptionAr: item.descriptionAr,
          image: item.image,
          imageMob: item.imageMob,
          imagePosition: item.imagePosition,
        };
        subHeadings.push(subtitles);
      });

      this.$apollo
        .mutate({
          mutation: require("../api/createArticle.graphql"),
          variables: {
            headingEn: this.headingEn,
            headingAr: this.headingAr,
            headingImage: this.headingImage,
            headingImageMob: this.headingImageMob,
            showOrder: parseInt(this.showOrder),
            subHeadings: subHeadings,
          },
          update: () => {
            this.$root.$emit("updateArticle");
            this.text = "Article Added";
            this.snackbar = true;
            this.btnloading = false;
            this.show_dialog_box = false;
            this.$refs.form.reset();
          },
        })

        .catch(error => {
          if (error.graphQLErrors != null) {
            console.error(error.graphQLErrors);
          }
          this.btnloading = false;
          this.show_dialog_box = false;
        });
    },
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
  },
};
</script>

<style>
.ql-toolbar .ql-formats .ql-image {
  display: none;
}
</style>
